import { type FC, type ReactNode, useEffect } from 'react'
import classNames from 'classnames'
import { EnumHelperText, HelperText } from 'shared/ui'
import { type IMessageFieldProps, MessageField } from 'widgets/MessageField'
import { type SMSMessageFieldStore } from './store/SMSMessageFieldStore'
import styles from './styles.module.scss'

interface SMSMessageFieldProps {
  smsMessageFieldStore: SMSMessageFieldStore
  errorMessage: ReactNode
  setDraggingCondition?: (condition: boolean) => void
  color?: IMessageFieldProps['color']
}

export const SMSMessageField: FC<SMSMessageFieldProps> = ({
  smsMessageFieldStore,
  errorMessage,
  setDraggingCondition,
  color,
}) => {
  const { messageFieldStore } = smsMessageFieldStore

  useEffect(() => {
    return () => {
      smsMessageFieldStore.dispose()
    }
  }, [])

  useEffect(() => {
    if (!!errorMessage) messageFieldStore.setHighlight('error')
    else messageFieldStore.clearHighlight()
  }, [errorMessage])

  return (
    <div className={styles.wrap}>
      <div
        className={classNames(styles.wrap, {
          [styles.activeState]: messageFieldStore.activeMessageField,
        })}
      >
        <div className={styles.alerts} ref={messageFieldStore.setAlertElement} />
        <MessageField
          messageFieldStore={messageFieldStore}
          onDragHandler={setDraggingCondition}
          color={color}
        />
      </div>
      {!!errorMessage && (
        <HelperText
          icon={'alertTriangleSmall'}
          variant={EnumHelperText.Error}
          text={errorMessage}
        />
      )}
    </div>
  )
}
